import React from 'react'
import {FieldErrors} from 'react-hook-form'
import {isEmptyObject} from '../../utils/common'

interface AccountSummaryProps {
    errors: FieldErrors
    fieldLabels?: Record<string, string>
}

const defaultFieldLabels: Record<string, string> = {
    password: 'New Password',
    confirm: 'Confirm New Password'
}

const AccountErrorSummary: React.FC<AccountSummaryProps> = ({errors, fieldLabels}) => {
    const resolvedLabels = {...defaultFieldLabels, ...fieldLabels}
    // Filter out the global error key
    const filteredErrors = Object.entries(errors).filter(([field]) => field !== 'global')
    return (
        !isEmptyObject(errors) && (
            <div className="text-sm bg-red-03 border border-red-02 text-red-04 px-4 py-3 rounded relative">
                <strong>Please fix the following errors:</strong>
                <ul className="mt-2 list-disc pl-5">
                    {filteredErrors.map(([field, error]) => {
                        return (
                            error?.message && (
                                <li key={field} className="capitalize pb-1">
                                    <strong>{resolvedLabels[field] || field}</strong>:
                                    <span className="pl-1">{String(error.message)}</span>
                                </li>
                            )
                        )
                    })}
                </ul>
            </div>
        )
    )
}

export default AccountErrorSummary
